import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const getSummativeReportAPI = async ({ child, reportID }: { child: ChildrenStoreData, reportID: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.get(`/child/${child.childId}/summative-report/${reportID}`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response?.data?.summativeReport;
        }
        return {};
    });
};

export const signSummativeReport = async ({ child, reportID, params }: { child: ChildrenStoreData, reportID: string, params: { comment: string, keepCopy: boolean, shareWithOther: boolean } }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.patch(`/child/${child.childId}/summative-report/${reportID}/sign`, params).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response;
        }
        return null;
    });
};

export const getTransitionReportAPI = async ({ child, reportID }: { child: ChildrenStoreData, reportID: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.get(`/child/${child.childId}/transition-report/${reportID}`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response?.data?.transitionReport;
        }
        return null;
    });
};

export const signTransitionReport = async ({ child, reportID, params }: { child: ChildrenStoreData, reportID: string, params: { comment: string, keepCopy: boolean, shareWithOther: boolean } }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();

    return retryAxios.patch(`/child/${child.childId}/transition-report/${reportID}/sign`, params).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response;
        }
        return null;
    });
};